
import React from "react";
import { TextField} from '@mui/material';

const CTxtFld = (props)=>{
    return <TextField
        {...props}
        size="large"
        variant="outlined" 
        fullWidth
    />
}

export default CTxtFld;